import {
    ADD_MODEL_FAIL,
    ADD_MODEL_SUCCESS,
    DELETE_MODEL_FAIL,
    DELETE_MODEL_SUCCESS,
    EXPORT_MODEL_FAIL,
    EXPORT_MODEL_SUCCESS,
    GET_MODEL_DETAILS_FAIL,
    GET_MODEL_DETAILS_SUCCESS,
    GET_MODEL_LISTING_FAIL,
    GET_MODEL_LISTING_SUCCESS,
    RESET_MODEL_ATTACHMENT_STATE,
    RESET_MODEL_STATE,
    UPDATE_MODEL_FAIL,
    UPDATE_MODEL_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    modelListing: [],
    modelDetails: [],
    addModel: [],
    updateModel: [],
    deleteModel: [],
    exportModel: [],
    error: [],
}

const Model = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_MODEL_LISTING_SUCCESS:
            return {
                ...state,
                modelListing: action.payload
            }
        case GET_MODEL_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_MODEL_DETAILS_SUCCESS:
            return {
                ...state,
                modelDetails: action.payload
            }
        case GET_MODEL_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_MODEL_SUCCESS:
            return {
                ...state,
                addModel: action.payload
            }
        case ADD_MODEL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_MODEL_SUCCESS:
            return {
                ...state,
                updateModel: action.payload
            }
        case UPDATE_MODEL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_MODEL_SUCCESS:
            return {
                ...state,
                deleteModel: action.payload
            }
        case DELETE_MODEL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_MODEL_SUCCESS:
            return {
                ...state,
                exportModel: action.payload
            }
        case EXPORT_MODEL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_MODEL_STATE:
            return {
                ...state,
                modelListing: [],
                modelDetails: [],
                addModel: [],
                updateModel: [],
                deleteModel: [],
                exportModel: [],
                error: [],
            }
        case RESET_MODEL_ATTACHMENT_STATE:
            return {
                ...state,
                exportModel: [],
                error: [],
            }
        default:
            return state
    }
}

export default Model
